import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToggleSwitchComponent {

  @Input() checked:boolean = false;
  @Input() disabled:boolean = false;
  @Output() checkedChange:EventEmitter<boolean> = new EventEmitter<boolean>;
  public guid:string = '';

  constructor(public utils:UtilService){
    this.guid = utils.newGuid();
  }

  public toggleChange(){
    if (this.disabled) {
      return;
    }
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }

}
